import { useNavigate } from "react-router-dom";

import { Button } from "@a2z/ui";


import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import { endpoints } from "@/lib/api/endpoints";
import { useLogoutMutation } from "@/shared/services/useLogoutMutation";
import { deregisterFcmTokenFromBackend } from "@/lib/firebase/fcm";

export function LogoutButton({
  redirectTo,
  className,
}: {
  endpoint?: typeof endpoints.seller.auth.logout;
  redirectTo: string;
  className?: string;
}) {
  const navigate = useNavigate();
  const t = useTranslations();
  const sellerLogoutMutation = useLogoutMutation();

  const handleLogout = async () => {
    // Deregister FCM token before logging out (best-effort)
    await deregisterFcmTokenFromBackend().catch(() => {});

    await sellerLogoutMutation.mutateAsync({});
    navigate(redirectTo, { replace: true });
  };

  return (
    <Button
      type="button"
      onClick={handleLogout}
      variant="outline"
      className={
        className ??
        "h-11 rounded-full px-4 text-sm font-semibold transition"
      }
    >
      {t(keys.common.logout)}
    </Button>
  );
}
